import { useGetConsumerPropertiesCauses } from '@givebacks/api/backer';
import { Stack, Text, Title } from 'ui';

import { ClickableOptionsCard } from '../../../../Cards/ClickableOptionsCard/ClickableOptionsCard';
import { ClickableCauseCard } from './AdditionalInformationModal';

const AdditionalInformation = () => {
  const { data } = useGetConsumerPropertiesCauses();

  if (data?.causes.length === 0) {
    return null;
  }

  return (
    <Stack>
      <Stack gap={4}>
        <Title order={3} fz="lg">
          Additional Information
        </Title>
        <Text fz="xs" c="gray">
          Review and edit your information for each organization.
        </Text>
      </Stack>
      <ClickableOptionsCard>
        {data?.causes.map((cause) => <ClickableCauseCard key={cause.uuid} causeId={cause.uuid} />)}
      </ClickableOptionsCard>
    </Stack>
  );
};

export { AdditionalInformation };
